import request from 'utils/request'

/**
 * 获取信用申请待审批列表
 * @param {*} data
 */
export const getAuditList = data => request().post('bp/task/page', data)

/**
 * 审批
 * @param {*} data
 */
export const doApprove = data => request(false).post('bp/approve', data)

/**
 * 获取批量申请待审批列表
 * @param {*} data
 */
export const getBatchAuditList = data =>
  request().post('bp/batch/task/page', data)

/**
 * 获取批量申请审批详情
 * @param {*} id
 */
export const getBatchApprovalDetail = id =>
  request().get(`bp/batch/task/detail/${id}`)

/**
 * 提交批量申请审批
 * @param {*} data
 */
export const doBatchApprove = data => request().post('bp/batch/approve', data)

export const downloadApplyTable = data =>
  request().post('bp/task/export', data, { responseType: 'arraybuffer' })

/**
 * 获取限额延期批量申请审批详情
 * @param {*} id
 */
export const getBatchLimitDetail = id =>
  request().get(`limit/batch/task/detail/${id}`)

/**
 * 限额延期提交批量申请审批
 * @param {*} data
 */
export const doLimitBatchApprove = data =>
  request().post('limit/batch/approve', data)

// 获取标准账期
export const getPeriodists = data =>
  request().post('accountPeriod/periodLists', data)

/**
 * 获取审批类型编辑权限
 */
export const getLevelBoolean = () => request().get('user/getLevelBoolean')
